import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const EducationItem = ({ edu }) => {

  const degree = edu.degree.toLowerCase().trim();

    return (
          <div className="achievement">

            { degree === 'javascript' && <Fragment>
            <i className="fab fa-js fa-3x"></i>
            <h3>{edu.degree}</h3>
            <p>{edu.school}</p>
            </Fragment> }

            { degree === 'high school' && <Fragment>
            <i className="fas fa-school fa-3x"></i>
            <h3>{edu.degree}</h3>
            <p>{edu.school}</p>
            </Fragment> }

            { degree === 'b.tech cse' && <Fragment>
            <i className="fas fa-university fa-3x"></i>
            <h3>{edu.degree}</h3>
            <p>{edu.school}</p>
            </Fragment> }

            { degree === 'pg dac' && <Fragment>
            <i className="fa fa-code fa-3x"></i>
            <h3>{edu.degree}</h3>
            <p>{edu.school}</p>
            </Fragment> }

          </div>
    )
}

EducationItem.propTypes = {
  edu: PropTypes.object.isRequired,
}

export default EducationItem
